import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Eye, AlertTriangle } from "lucide-react";

const segments = (s, len) => {
  if (!s) return 0;
  const uni = /[^\x00-\x7F]/.test(s);
  const single = uni ? 70 : 160;
  const multi = uni ? 67 : 153;
  return len <= single ? 1 : Math.ceil(len / multi);
};

export const MessagePreview = ({ endpoint, body, fileId, filename }) => {
  const [data, setData] = useState(null);
  useEffect(() => {
    if (!body.trim() && !fileId && !filename) { setData(null); return undefined; }
    let live = true;
    const t = setTimeout(async () => {
      try {
        const res = await api.post(endpoint, { body, file_id: fileId || null, filename: filename || null, preview: true });
        if (live) setData(res.data);
      } catch { if (live) setData(null); }
    }, 400);
    return () => { live = false; clearTimeout(t); };
  }, [endpoint, body, fileId, filename]);

  if (!data) return null;
  const len = data.length ?? data.body.length;
  const n = segments(data.body, len);
  return (
    <div data-testid="patient-message-preview" className="rounded-lg border border-slate-200 bg-slate-50 p-3">
      <div className="flex items-center justify-between text-xs font-semibold text-slate-500 uppercase tracking-wide mb-2">
        <span className="flex items-center gap-1.5"><Eye className="h-3.5 w-3.5" /> Patient will see</span>
        <span data-testid="patient-message-segments" className="normal-case font-normal text-slate-400">
          {len} characters · {n} text{n === 1 ? "" : "s"}
        </span>
      </div>
      <div className="flex justify-end">
        <div data-testid="patient-message-preview-body" className="max-w-[90%] bg-[#0B1F44] text-white rounded-2xl rounded-br-sm px-3.5 py-2 text-sm whitespace-pre-wrap break-words">
          {data.body}
        </div>
      </div>
      {data.warnings?.map((w) => (
        <div key={w} data-testid="patient-message-warning" className="mt-2 flex items-start gap-1.5 text-xs text-amber-700">
          <AlertTriangle className="h-3.5 w-3.5 mt-0.5 shrink-0" />{w}
        </div>
      ))}
    </div>
  );
};
